const DEFAULT_API_BASE = (
  process.env.REACT_APP_API_BASE || "https://node.matlib.net"
).replace(/\/$/, "");

export const API_BASE_URL = DEFAULT_API_BASE;
export const MATERIAL_URL = `${API_BASE_URL}/material/`;
export const ROOT_SERVER = `${API_BASE_URL}/`;
export const NIKESTORE = `${API_BASE_URL}/brand/`;

export function buildApiUrl(path) {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  return `${API_BASE_URL}${normalizedPath}`;
}
